import { runningInBrowser } from "~/const/browser";

export const handleLocalStorage = () => {
  const setLocalStorage = (data: unknown, key: string) => {
    if (!runningInBrowser) return;
    try {
      localStorage.setItem(key, JSON.stringify(data));
    } catch (e) {
      localStorage.clear();
    }
  };

  const getLocalStorage = <T = string>(key: string): T | undefined => {
    if (!runningInBrowser) return;
    try {
      const item = localStorage.getItem(key);
      //文字列のnullをparseするとnullを返す
      if (item === null || item === "null") return;
      return JSON.parse(item);
    } catch (e) {
      return;
    }
  };

  const removeLocalStorage = (key: string) => {
    if (!runningInBrowser) return;
    try {
      localStorage.removeItem(key);
    } catch (e) {
      return;
    }
  };

  return {
    setLocalStorage,
    getLocalStorage,
    removeLocalStorage,
  };
};
